import {Card, FC, Form} from 'external/react'
import FormTextfield, { PasswordField } from 'components/FormTextfield'
import useParent from 'context/parent-context/hook'

type EditUserFormProps =  {
	errors: any
}

const EditUserForm: FC<EditUserFormProps> = props => {

	const {errors} = props

    const {update, state: {modals: {editUser: {user}}}} = useParent()

	function createFieldProps (placeholder: any, fieldName: string | number, maxLength?: any) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: user[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e: { target: { value: string } }) => {
				update({modals: {editUser: {user: {[fieldName]: {$set: e.target.value.trim()}}}}})
			}
		}
	}

    return (
        <Form>
                <FormTextfield {...createFieldProps('Nombre', 'first_name', 25)} />
                <FormTextfield {...createFieldProps('Apellido', 'last_name', 25)} />
                <FormTextfield {...createFieldProps('Correo', 'email')} />
                <FormTextfield {...createFieldProps('Télefono', 'phone')} />
           <Card>
                <Card.Body>
                    <div className='d-flex'>
                        <Form.Label className='d-flex flex-column justify-content-center col-sm-2'>Usuario</Form.Label>
                        <FormTextfield className='col-sm-4' {...createFieldProps('Usuario', 'username')} controlProps={{disabled: true}} />
                    </div>
                    <div className='d-flex'>
                        <Form.Label className='d-flex flex-column justify-content-center col-sm-2'>Contraseña</Form.Label>
                        <PasswordField className='col-sm-4' controlProps={{autoComplete: 'new-password'}} {...createFieldProps('Contraseña', 'password')} />
                    </div>
                </Card.Body>
            </Card>
        </Form>
    )
}

export {EditUserForm as default}